import { IGuid } from './ITypes';

// Sentinel "product" id used only inside the LicensePortal Subscription form to
// offer Forms PowerPages licenses. It is NOT a dbo.Subscription product - when
// selected the form posts to the dedicated /management/forms-license endpoint.
export const FORMS_POWERPAGES_PRODUCT = 100;

export enum FormsLicenseType {
	Anonymous = 0,
	Authenticated = 1,
}

export interface IFormsLicenseRequest {
	OrganizationId: IGuid;
	OrganizationUrl?: string | null;
	OrganizationName?: string | null;
	Url?: string | null;
	LicenseType: FormsLicenseType;
	IsTrial: boolean;
	ExpiresOn: string;
	UserSoftLimit?: number | null;
	UserHardLimit?: number | null;
	DeviceSoftLimit?: number | null;
	DeviceHardLimit?: number | null;
}

export interface IFormsLicense {
	LicenseId: IGuid;
	OrganizationId: IGuid;
	CreatedOn?: string | null;
	Url: string;
	LicenseType: FormsLicenseType;
	IsTrial: boolean;
	ExpiresOn: string;
	UserSoftLimit: number;
	UserHardLimit: number;
	DeviceSoftLimit: number;
	DeviceHardLimit: number;
}
